import dynamic from 'next/dynamic'
import GLoading from 'tennders-market/common/components/element/GLoading'
import { memo, useEffect, useState } from 'react'
import { isNil } from 'lodash'

const DetailMapView = dynamic(() => import('tennders-transactions/views/map/DetailMapView'), {
  ssr: false,
  loading: () => (
    <div
      style={{
        width: '100%',
        minHeight: 200,
        background: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <GLoading />
    </div>
  )
})

type HiddenMapViewProps = {
  showMap?: boolean
}

const HiddenMapView = ({ showMap }: HiddenMapViewProps) => {
  const [shown, setShown] = useState(false)

  useEffect(() => {
    if (!isNil((showMap))) {
      setShown(showMap)
    } else {
      setTimeout(() => setShown(true), 500)
    }
    return () => setShown(false)
  }, [showMap])

  return <DetailMapView showMap={shown} />
}

export default memo(HiddenMapView)
